// extracted by mini-css-extract-plugin
export var activeFilterButton = "_rl-c";
export var backButton = "_rl-4";
export var backIcon = "_rl-5";
export var chevronShortcut = "_rl-6";
export var container = "_rl-1";
export var editor = "_rl-8";
export var editorWrapper = "_rl-7";
export var prefix = "_rl-2";
export var searchIcon = "_rl-3";
export var suffix = "_rl-9";
export var suffixContent = "_rl-a";
export var suffixText = "_rl-b";
export var wrapper = "_rl-0";